import { AiChatAgent } from "../../types/AIChat/AiChatThread";

export type VoiceRecordingStatus = "idle" | "requesting_permission" | "recording" | "transcribing" | "sending" | "error";

export type VoiceContext = {
  backofficeCaseId: number | null;
  activeThreadId: number | null;
  activeAgent: AiChatAgent;
  activeEditStepId: number | null;
  locationKey: string;
  isPanelExpanded: boolean;
};

export const canCancelVoiceRecording = (status: VoiceRecordingStatus): boolean =>
  ["requesting_permission", "recording", "transcribing"].includes(status);

export const isVoiceContextCurrent = (
  saved: VoiceContext,
  current: VoiceContext,
  expectedThreadId = saved.activeThreadId,
): boolean =>
  current.backofficeCaseId === saved.backofficeCaseId &&
  current.activeThreadId === expectedThreadId &&
  current.activeAgent === saved.activeAgent &&
  current.activeEditStepId === saved.activeEditStepId &&
  current.locationKey === saved.locationKey &&
  current.isPanelExpanded === saved.isPanelExpanded;
